import { defineComponent as _defineComponent } from 'vue'
import { computed, nextTick, ref, watch, provide } from "vue";

interface MenuCoordinates {
  x: number;
  y: number;
}

interface MenuItem {
  id: string;
  // This update is broadcast to all menu items when
  // the enter or space keys are used to select a menu item.
  // Note that the broadcast does not indicate which item
  // was selected. That is provided separately as the
  // active descendant ID.
  update_item_activated_with_keyboard: () => unknown;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'context_menu',
  props: {
    coordinates: null,
    is_open: { type: Boolean }
  },
  setup(__props: any, { emit }: { emit: ({
  close: [];
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  coordinates: MenuCoordinates;
  is_open: boolean;
};





const active_index = ref(0);

const root = ref<HTMLElement | null>(null);

const items = ref<MenuItem[]>([]);

provide(
  "register",
  (id: string, update_item_activated_with_keyboard: () => unknown) => {
    items.value.push({ id, update_item_activated_with_keyboard });
  },
);
const active_descendent_id = computed(() => {
  if (items.value.length !== 0) {
    return items.value[active_index.value].id;
  }
  return "";
});
provide("active_descendent_id", active_descendent_id);

function broadcast_item_activated_with_keyboard() {
  for (const menu_item of items.value) {
    menu_item.update_item_activated_with_keyboard();
  }
}

function focus_next_item() {
  active_index.value = (active_index.value + 1) % items.value.length;
}

function focus_prev_item() {
  active_index.value =
    (active_index.value - 1 + items.value.length) % items.value.length;
}

watch(
  () => props.is_open,
  (is_open) => {
    if (!is_open) {
      return;
    }

    // Wait for v-show to make the element visible before measuring and
    // focusing it: focus() is a no-op on a `display: none` element, and the
    // ESC-to-close handler needs the element focused.
    nextTick(() => {
      const el = root.value;
      if (el === null) {
        return;
      }

      el.style.left = "0px";
      el.style.top = "0px";
      const height = el.clientHeight;
      const width = el.clientWidth;

      let left = props.coordinates.x;
      let top = props.coordinates.y;
      if (left + width > document.body.clientWidth) {
        left = left - width - 5;
      }
      if (top + height > document.body.clientHeight) {
        top = top - height - 5;
      }

      el.style.left = `${left}px`;
      el.style.top = `${top}px`;

      el.focus();
    });
  },
);

return { __sfc: true,props, emit, active_index, root, items, active_descendent_id, broadcast_item_activated_with_keyboard, focus_next_item, focus_prev_item }
}

})